import React from 'react';
import FooterLogo from '../FooterLogo';
import CopyRight from '../CopyRight';
import RightSection from './RightSection';
import ContentPolicy from './ContentPolicy';
import { Link } from 'react-router-dom';

function Login() {
  return (
    <section className="login-page brain-pointer-none privacy-policy-page">
      {/* <Link href="" className="back-btn">
        <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21.5 9C21.5 9.23206 21.4078 9.45462 21.2437 9.61872C21.0796 9.78281 20.8571 9.875 20.625 9.875H3.48703L9.86906 16.2559C9.95036 16.3372 10.0148 16.4337 10.0588 16.54C10.1028 16.6462 10.1255 16.76 10.1255 16.875C10.1255 16.99 10.1028 17.1038 10.0588 17.21C10.0148 17.3163 9.95036 17.4128 9.86906 17.4941C9.78777 17.5754 9.69125 17.6398 9.58504 17.6838C9.47882 17.7278 9.36497 17.7505 9.25 17.7505C9.13503 17.7505 9.02119 17.7278 8.91497 17.6838C8.80875 17.6398 8.71223 17.5754 8.63094 17.4941L0.755939 9.61906C0.674585 9.5378 0.610046 9.44129 0.566012 9.33507C0.521978 9.22885 0.499313 9.11499 0.499313 9C0.499313 8.88501 0.521978 8.77115 0.566012 8.66493C0.610046 8.5587 0.674585 8.4622 0.755939 8.38094L8.63094 0.505936C8.79512 0.34175 9.01781 0.249512 9.25 0.249512C9.48219 0.249512 9.70488 0.34175 9.86906 0.505936C10.0332 0.670121 10.1255 0.892805 10.1255 1.125C10.1255 1.35719 10.0332 1.57988 9.86906 1.74406L3.48703 8.125H20.625C20.8571 8.125 21.0796 8.21719 21.2437 8.38128C21.4078 8.54537 21.5 8.76793 21.5 9Z" fill="#1C75BC" />
        </svg>
      </Link> */}
      <div className="container-fluid pd-80">
        <div className="row align-items-center flex-column flex-md-row-reverse flex-lg-row-reverse">
          <div className="col-xl-3 col-lg-3 col-md-12 col-12 d-inline-block align-self-end order-3">
            <FooterLogo />
          </div>
          <div className="col-xl-5 col-lg-5 col-md-12 col-12 order-2">
            <ContentPolicy />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-12 col-12 order-1 d-none d-lg-block">
            <RightSection />
          </div>
        </div>
        <CopyRight />
      </div>
    </section>
  );
}

export default Login;